import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { Form } from '../../../../components/ui/form'
import { FormNotices } from './form/formNotices'
import useAddNotices from './hooks/useAddNotices'

export const AdminAddNotices = () => {
  const { loading, formContext, setFormContext, HandleAddConsents } = useAddNotices()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Form.Root
        action={() => {
          HandleAddConsents()
        }}
      >
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-3">Adicionar Aviso</p>
          </Column.Content>
        </Column.Root>
        <FormNotices loading={loading} values={formContext} setValues={setFormContext} disabledList={{}} />
      </Form.Root>
    </Page.Section>
  )
}
